import { memo } from "react"

const IconEventsCard = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="5.33333" fill="#7B78E1" fill-opacity="0.3" />
      <path d="M9.33333 7.33333H6" stroke="#002C98" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.334 8.66667H10.0007C9.63265 8.66667 9.33398 8.368 9.33398 8V6.66667C9.33398 6.29867 9.63265 6 10.0007 6H17.334C17.702 6 18.0007 6.29867 18.0007 6.66667V8C18.0007 8.368 17.702 8.66667 17.334 8.66667Z"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M9.33333 12.0013H6" stroke="#002C98" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.334 13.3346H10.0007C9.63265 13.3346 9.33398 13.036 9.33398 12.668V11.3346C9.33398 10.9666 9.63265 10.668 10.0007 10.668H17.334C17.702 10.668 18.0007 10.9666 18.0007 11.3346V12.668C18.0007 13.036 17.702 13.3346 17.334 13.3346Z"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.334 17.9987H10.0007C9.63265 17.9987 9.33398 17.7 9.33398 17.332V15.9987C9.33398 15.6307 9.63265 15.332 10.0007 15.332H17.334C17.702 15.332 18.0007 15.6307 18.0007 15.9987V17.332C18.0007 17.7 17.702 17.9987 17.334 17.9987Z"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33333 16.6667H6.66667C6.29867 16.6667 6 16.368 6 16V6"
        stroke="#002C98"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconEventsCard)
